const apiUrl = process.env.REACT_APP_API_URL;
export const GetComandaAfegitId = async ( page : string, id : number) => {
    try {
        const response = await fetch(`${apiUrl}:8072/comandes/afegit/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
